webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);


var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSearchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchMusic; });
/* harmony export (immutable) */ __webpack_exports__["e"] = loadFavoritesList;
/* harmony export (immutable) */ __webpack_exports__["b"] = toggleMusicFavorite;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadPlaylist;
/* harmony export (immutable) */ __webpack_exports__["f"] = addMusicToPlaylist;
/* harmony export (immutable) */ __webpack_exports__["d"] = clearPlaylist;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);





var baseUrl = 'https://api.obfs.dev/api/netease/';
var store = {
  favorites: [],
  playlist: []

  // 存储状态到客户端本地
};var saveLocalData = function saveLocalData(data) {
  try {
    localStorage.setItem('data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
  } catch (err) {
    // 忽略写入错误
  }
};

// 载入客户端本地状态
var loadLocalData = function loadLocalData() {
  try {
    var data = localStorage.getItem('data');
    if (data === null) {
      return undefined;
    }
    return JSON.parse(data);
  } catch (err) {
    return undefined;
  }
};

var localData = loadLocalData();
if (localData) {
  store = localData;
}

// 请求搜索音乐列表
var fetchSearchList = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(keyword) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(baseUrl, {
              params: {
                type: 'search',
                search_type: 1,
                s: keyword,
                offset: offset,
                limit: limit
              }
            });

          case 2:
            response = _context.sent;


            // 合成收藏状态
            response.data.result.songs = response.data.result.songs.map(function (item) {
              item.favorited = store.favorites.some(function (f) {
                return f.id === item.id;
              });
              return item;
            });

            return _context.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchSearchList(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 请求指定ID的歌曲
var fetchMusic = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(baseUrl, {
              params: {
                type: 'song',
                id: id,
                br: 128000
              }
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt('return', response.data.data[0]);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fetchMusic(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

// 获取收藏列表
function loadFavoritesList() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

  return {
    favorites: store.favorites.slice(offset, limit + offset + 1),
    songCount: store.favorites.length
  };
}

// 切换歌曲收藏状态
function toggleMusicFavorite(musicItem) {
  var index = store.favorites.findIndex(function (item) {
    return item.id === musicItem.id;
  });
  var favorited = index !== -1;
  if (favorited) {
    store.favorites.splice(index, 1);
    musicItem.favorited = false;
  } else {
    musicItem.favorited = true;
    store.favorites.push(musicItem);
  }

  saveLocalData(store);
  return !favorited;
}

// 获取播放列表
function loadPlaylist() {
  return store.playlist;
}

// 添加歌曲到播放列表
function addMusicToPlaylist(musicItem) {
  if (!store.playlist.some(function (item) {
    return item.id === musicItem.id;
  })) {
    store.playlist.push(musicItem);
    saveLocalData(store);
    __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* eventBus */].$emit('playlistChange', store.playlist);
  }
  return store.playlist;
}

// 清空播放列表
function clearPlaylist() {
  store.playlist = [];
  __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* eventBus */].$emit('playlistChange', store.playlist);
  saveLocalData(store);
}

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4704b214",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Favorites__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Favorites___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Favorites__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/favorites',
    name: 'favorites',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Favorites___default.a
  }]
}));

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(148),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(58);







__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MusicSearchBox__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MusicSearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_MusicSearchBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MusicPlayer__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MusicPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MusicPlayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      drawer: true
    };
  },


  components: {
    MusicSearchBox: __WEBPACK_IMPORTED_MODULE_0__components_MusicSearchBox___default.a,
    MusicPlayer: __WEBPACK_IMPORTED_MODULE_1__components_MusicPlayer___default.a
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicList',

  props: ['items'],

  data: function data() {
    return {
      currentMusicItem: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* eventBus */].$on('musicChange', function (musicItem) {
      _this.currentMusicItem = musicItem;
    });
  },


  filters: {
    parseDuration: function parseDuration(dt) {
      if (!dt) return '00:00';
      var m = parseInt(dt / 1000 / 60).toString().padStart(2, '0');
      var s = parseInt(dt / 1000 % 60).toString().padStart(2, '0');
      return m + ':' + s;
    }
  },

  methods: {
    playMusic: function playMusic(musicItem) {
      this.currentMusicItem = musicItem;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["f" /* addMusicToPlaylist */])(musicItem);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* eventBus */].$emit('musicChange', musicItem);
    },
    toggleFavorite: function toggleFavorite(musicItem) {
      var favorited = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* toggleMusicFavorite */])(musicItem);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* eventBus */].$emit('favoritesChange', musicItem, favorited);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MusicPlaylist__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MusicPlaylist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MusicPlaylist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicPlayer',

  components: {
    MusicPlaylist: __WEBPACK_IMPORTED_MODULE_2__components_MusicPlaylist___default.a
  },

  data: function data() {
    return {
      paused: true,
      volume: 100,
      progress: 0,
      currentTime: 0,
      currentMusic: null,
      currentMusicItem: null,
      showPlaylist: false,
      showVolumeControls: false,
      playMode: 'list',
      playModeIcon: {
        list: 'playlist_play',
        random: 'shuffle',
        repeatOne: 'repeat_one'
      }
    };
  },


  watch: {
    volume: function volume() {
      if (this.currentMusic) {
        this.$refs.audio.volume = this.volume / 100;
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* eventBus */].$on('musicChange', function (musicItem) {
      _this.currentMusicItem = musicItem;
      _this.getMusic(musicItem);
    });

    __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* eventBus */].$on('favoritesChange', function (musicItem, favorited) {
      if (_this.currentMusicItem && _this.currentMusicItem.id === musicItem.id) {
        _this.currentMusicItem.favorited = favorited;
      }
    });

    document.addEventListener('click', function () {
      _this.showVolumeControls = false;
      _this.showPlaylist = false;
    });
  },


  filters: {
    parseDuration: function parseDuration(dt) {
      if (!dt) return '00:00';
      var m = parseInt(dt / 60).toString().padStart(2, '0');
      var s = parseInt(dt % 60).toString().padStart(2, '0');
      return m + ':' + s;
    }
  },

  methods: {
    getMusic: function getMusic(musicItem) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* fetchMusic */])(musicItem.id);

              case 2:
                _this2.currentMusic = _context.sent;

                _this2.$refs.audio && _this2.$refs.audio.load();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    switchPlayMode: function switchPlayMode() {
      if (this.playMode === 'list') {
        this.playMode = 'random';
      } else if (this.playMode === 'random') {
        this.playMode = 'repeatOne';
      } else if (this.playMode === 'repeatOne') {
        this.playMode = 'list';
      }
    },
    togglePlay: function togglePlay() {
      if (!this.$refs.audio) {
        return;
      }

      if (this.$refs.audio.paused) {
        this.$refs.audio.play();
        this.paused = false;
      } else {
        this.$refs.audio.pause();
        this.paused = true;
      }
    },
    playPrev: function playPrev() {
      __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* eventBus */].$emit('playPrev', this.playMode);
    },
    playNext: function playNext() {
      __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* eventBus */].$emit('playNext', this.playMode);
    },
    updateTime: function updateTime() {
      var audio = this.$refs.audio;
      this.currentTime = audio.currentTime;
      this.progress = parseInt(audio.currentTime / audio.duration * 100);
    },
    setTime: function setTime() {
      var audio = this.$refs.audio;
      if (isNaN(this.progress / 100 * audio.duration)) {
        return;
      }

      audio.currentTime = this.progress / 100 * audio.duration;
    },
    toggleFavorite: function toggleFavorite(musicItem) {
      if (!musicItem) return;

      var favorited = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["b" /* toggleMusicFavorite */])(musicItem);
      __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* eventBus */].$emit('favoritesChange', musicItem, favorited);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicPlaylist',

  data: function data() {
    return {
      items: [],
      confirmDialog: false,
      currentMusicItem: null
    };
  },


  computed: {
    currentMusicIndex: function currentMusicIndex() {
      var _this = this;

      return this.items.findIndex(function (item) {
        return item.id === _this.currentMusicItem.id;
      });
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* eventBus */].$on('musicChange', function (musicItem) {
      _this2.currentMusicItem = musicItem;
    });

    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* eventBus */].$on('playlistChange', function (palylist) {
      _this2.items = palylist;
    });

    var getNextItem = function getNextItem(playMode) {
      var isPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var nextMusicItem = _this2.currentMusicItem;
      var step = isPrev ? -1 : 1;
      var nextIndex = _this2.currentMusicIndex + step;
      if (playMode === 'list') {
        if (nextIndex >= _this2.items.length) {
          nextIndex = 0;
        } else if (nextIndex < 0) {
          nextIndex = _this2.items.length - 1;
        }
        nextMusicItem = _this2.items[nextIndex];
      } else if (playMode === 'random') {
        if (_this2.items.length > 1) {
          nextIndex = Math.floor(Math.random() * (_this2.items.length - 1));
          var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this2.items));
          items.splice(_this2.currentMusicIndex, 1);
          nextMusicItem = items[nextIndex];
        }
      }

      return nextMusicItem;
    };

    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* eventBus */].$on('playPrev', function (playMode) {
      var nextMusicItem = getNextItem(playMode, true);
      _this2.playMusic(nextMusicItem);
    });

    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* eventBus */].$on('playNext', function (playMode) {
      var nextMusicItem = getNextItem(playMode);
      _this2.playMusic(nextMusicItem);
    });

    this.getPlaylist();
  },


  filters: {
    parseDuration: function parseDuration(dt) {
      if (!dt) return '00:00';
      var m = parseInt(dt / 1000 / 60).toString().padStart(2, '0');
      var s = parseInt(dt / 1000 % 60).toString().padStart(2, '0');
      return m + ':' + s;
    }
  },

  methods: {
    getPlaylist: function getPlaylist() {
      this.items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["c" /* loadPlaylist */])();
    },
    playMusic: function playMusic(musicItem) {
      this.currentMusicItem = musicItem;
      __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* eventBus */].$emit('musicChange', musicItem);
    },
    clear: function clear() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api__["d" /* clearPlaylist */])();
      this.confirmDialog = false;
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MusicSearchBox',
  data: function data() {
    return {
      keyword: this.$route.query.s || ''
    };
  },


  watch: {
    $route: function $route() {
      if (this.$route.name === 'home') {
        this.keyword = this.$route.query.s || '';
      }
    }
  },

  methods: {
    search: function search() {
      this.$router.push({ name: 'home', query: { s: this.keyword } });
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MusicList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MusicList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MusicList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Favorites',
  data: function data() {
    return {
      songCount: 0,
      page: parseInt(this.$route.query.p) || 1,
      pageItems: 20,
      items: []
    };
  },


  computed: {
    pageTotal: function pageTotal() {
      return Math.ceil(this.songCount / this.pageItems);
    }
  },

  watch: {
    $route: function $route() {
      this.page = parseInt(this.$route.query.p) || 1;
      this.getFavoritesList();
    },
    page: function page() {
      this.$router.push({ name: 'favorites', query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, { p: this.page }) });
    }
  },

  methods: {
    getFavoritesList: function getFavoritesList() {
      var offset = this.pageItems * (this.page - 1);
      var ret = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["e" /* loadFavoritesList */])(offset, this.pageItems);

      this.items = ret.favorites;
      this.songCount = ret.songCount;
    }
  },

  created: function created() {
    var _this = this;

    this.getFavoritesList();

    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* eventBus */].$on('favoritesChange', function (musicItem, favorited) {
      _this.items = _this.items.map(function (item) {
        if (item.id === musicItem.id) {
          item.favorited = favorited;
        }
        return item;
      });
    });
  },


  components: {
    MusicList: __WEBPACK_IMPORTED_MODULE_1__components_MusicList___default.a
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MusicList__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MusicList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MusicList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      loading: false,
      songCount: 0,
      page: parseInt(this.$route.query.p) || 1,
      pageItems: 50,
      items: []
    };
  },


  computed: {
    pageTotal: function pageTotal() {
      return Math.ceil(this.songCount / this.pageItems);
    }
  },

  watch: {
    $route: function $route() {
      this.page = parseInt(this.$route.query.p) || 1;
      this.getSearchList();
    },
    page: function page() {
      this.$router.push({ name: 'home', query: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.$route.query, { p: this.page }) });
    }
  },

  methods: {
    getSearchList: function getSearchList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var keyword, offset, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keyword = _this.$route.query.s || '';

                _this.loading = false;
                _this.items = [];
                _this.songCount = 0;

                if (keyword) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:

                _this.loading = true;
                offset = _this.pageItems * (_this.page - 1);
                _context.next = 10;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api__["g" /* fetchSearchList */])(keyword, offset, _this.pageItems);

              case 10:
                res = _context.sent;

                _this.loading = false;
                _this.items = res.result.songs;
                _this.songCount = res.result.songCount;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  created: function created() {
    var _this2 = this;

    this.getSearchList();

    __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* eventBus */].$on('favoritesChange', function (musicItem, favorited) {
      _this2.items = _this2.items.map(function (item) {
        if (item.id === musicItem.id) {
          item.favorited = favorited;
        }
        return item;
      });
    });
  },


  components: {
    MusicList: __WEBPACK_IMPORTED_MODULE_3__components_MusicList___default.a
  }
});

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(150),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(151),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(147),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(146),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(145),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "home"
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [(_vm.songCount > 0) ? _c('div', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("“" + _vm._s(_vm.$route.query.s) + "”的搜索结果")]), _vm._v(" "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v("找到 " + _vm._s(_vm.songCount) + " 首歌曲")])]) : (!_vm.loading) ? _c('div', {
    staticClass: "empty-tips"
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("library_music")]), _vm._v(" "), (!!_vm.$route.query.s) ? _c('p', [_vm._v("无“" + _vm._s(_vm.$route.query.s) + "”相关歌曲")]) : _c('p', [_vm._v("您尚未搜索任何歌曲")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('v-progress-circular', {
    staticClass: "teal--text text--lighten-2",
    attrs: {
      "indeterminate": "",
      "size": 60
    }
  }), _vm._v(" "), _c('p', [_vm._v("加载中...")])], 1)]), _vm._v(" "), _c('music-list', {
    attrs: {
      "items": _vm.items
    }
  }), _vm._v(" "), (_vm.pageTotal > 1) ? _c('v-card-text', {
    staticClass: "pagination-container"
  }, [_c('v-pagination', {
    attrs: {
      "circle": "",
      "length": _vm.pageTotal
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "favorites"
  }, [(_vm.songCount === 0) ? _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "empty-tips"
  }, [_c('v-icon', {
    staticClass: "grey--text text--lighten-1",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("library_music")]), _vm._v(" "), _c('p', [_vm._v("您尚未收藏任何歌曲")])], 1)]) : _vm._e(), _vm._v(" "), _c('music-list', {
    attrs: {
      "items": _vm.items
    }
  }), _vm._v(" "), (_vm.pageTotal > 1) ? _c('v-card-text', {
    staticClass: "pagination-container"
  }, [_c('v-pagination', {
    attrs: {
      "circle": "",
      "length": _vm.pageTotal
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    staticClass: "music-search-box",
    attrs: {
      "label": "搜索歌曲",
      "append-icon": "search",
      "type": "search",
      "dark": "",
      "single-line": "",
      "hide-details": "",
      "append-icon-cb": _vm.search
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.search($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app",
      "toolbar": "",
      "footer": "",
      "fixed-footer": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "persistent": "",
      "clipped": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("主页")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'favorites'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("favorite")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("收藏的歌")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-navbar teal lighten-2",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Vue Music Box")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('music-search-box'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": {
        name: 'favorites'
      },
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("favorite")])], 1)], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "grey darken-3",
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [_c('music-player')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [(index !== 0) ? _c('v-divider', {
      key: index,
      attrs: {
        "inset": true
      }
    }) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
      key: item.id,
      staticClass: "list__tile--link",
      attrs: {
        "avatar": ""
      },
      on: {
        "dblclick": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.playMusic(item)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.al.picUrl
      }
    })]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.playMusic(item)
        },
        "dblclick": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.currentMusicItem && _vm.currentMusicItem.id === item.id) ? _c('v-icon', {
      staticClass: "teal--text text--lighten-2"
    }, [_vm._v("play_circle_outline")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v("歌手：" + _vm._s(item.ar.map(function (e) { return e.name; }).join(' / ')))]), _vm._v(" "), _c('span', {
      staticClass: "mx-3"
    }, [_vm._v("时长：" + _vm._s(_vm._f("parseDuration")(item.dt)))]), _vm._v(" "), _c('span', [_vm._v("专辑：" + _vm._s(item.al.name))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleFavorite(item)
        },
        "dblclick": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(item.favorited) ? _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("favorite")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("favorite_border")])], 1)], 1)], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-player"
  }, [(_vm.currentMusic) ? _c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.currentMusic.url,
      "autoplay": ""
    },
    on: {
      "playing": function($event) {
        _vm.paused = false
      },
      "pause": function($event) {
        _vm.paused = true
      },
      "timeupdate": _vm.updateTime,
      "ended": _vm.playNext
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }, [(_vm.currentMusicItem) ? _c('img', {
    attrs: {
      "src": _vm.currentMusicItem.al.picUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions-before"
  }, [_c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.playPrev
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.togglePlay
    }
  }, [(!_vm.paused) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("pause")]) : _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.playNext
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_next")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('p', [(_vm.currentMusicItem) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.currentMusicItem.name))]), _vm._v("\n        - "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.currentMusicItem.ar.map(function (e) { return e.name; }).join(' / ')))])]) : _c('span', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("尚未播放歌曲")])]), _vm._v(" "), (_vm.currentMusicItem) ? _c('span', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDuration")(_vm.currentTime)))]), _vm._v("\n        / "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm._f("parseDuration")(_vm.currentMusicItem.dt / 1000)))])]) : _vm._e()]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "dark": "",
      "disabled": !_vm.currentMusic
    },
    on: {
      "input": _vm.setTime
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions-after"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleFavorite(_vm.currentMusicItem)
      }
    }
  }, [(_vm.currentMusicItem && _vm.currentMusicItem.favorited) ? _c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("favorite")]) : _c('v-icon', [_vm._v("favorite_border")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchPlayMode($event)
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.playModeIcon[_vm.playMode]))])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showVolumeControls = !_vm.showVolumeControls
      }
    }
  }, [(_vm.volume > 0) ? _c('v-icon', [_vm._v("volume_up")]) : _c('v-icon', [_vm._v("volume_off")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPlaylist = !_vm.showPlaylist
      }
    }
  }, [_c('v-icon', [_vm._v("queue_music")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVolumeControls),
      expression: "showVolumeControls"
    }],
    staticClass: "volume-controls",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-slider', {
    attrs: {
      "dark": "",
      "prepend-icon": _vm.volume > 0 ? 'volume_up' : 'volume_off'
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('music-playlist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlaylist),
      expression: "showPlaylist"
    }]
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-playlist",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "music-playlist-header"
  }, [_vm._v("\n    播放列表\n    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0),
      expression: "items.length > 0"
    }],
    staticClass: "clear-btn",
    attrs: {
      "title": "清空"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmDialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)]), _vm._v(" "), (_vm.items.length === 0) ? _c('div', {
    staticClass: "empty-playlist-tips"
  }, [_vm._v("播放列表是空的")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "music-playlist-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id,
      class: {
        current: _vm.currentMusicItem && _vm.currentMusicItem.id === item.id
      },
      on: {
        "dblclick": function($event) {
          _vm.playMusic(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.ar.map(function (e) { return e.name; }).join(' / ')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("parseDuration")(item.dt)))])])
  })), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "grey darken-3 white--text"
  }, [_c('v-card-text', [_vm._v("确认要清空播放列表吗？")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "dark": "",
      "error": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clear($event)
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[81]);


// WEBPACK FOOTER //
// static/js/app.92161bbb0c9952472347.js